export default __webpack_public_path__ + "static/media/3DPill.ae402bfc.svg";